<!-- Loading -->
<div class="bd-loading" *ngIf="!ready">
  <div class="bd-loading__dots"><span></span><span></span><span></span></div>
  <p class="bd-loading__text">Generando documento…</p>
</div>

<!-- Content -->
<ng-container *ngIf="ready">
  <div class="bd-header">
    <div class="bd-header__icon-wrap">
      <mat-icon>account_balance</mat-icon>
    </div>
    <div>
      <h2 mat-dialog-title class="bd-header__title">Balance Sumas y Saldos</h2>
      <p class="bd-header__sub">Selecciona el rango de fechas y exporta a Excel</p>
    </div>
    <button mat-icon-button class="bd-close" (click)="closeDialog()" matTooltip="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="bd-content">
    <mat-slide-toggle [(ngModel)]="global" name="global" class="bd-toggle">
      Todas las actividades
    </mat-slide-toggle>

    <div class="bd-dates">
      <mat-form-field appearance="outline" class="bd-field">
        <mat-label>Desde</mat-label>
        <mat-icon matPrefix>event</mat-icon>
        <input matInput [matDatepicker]="from" [(ngModel)]="fromDate" required />
        <mat-datepicker-toggle matSuffix [for]="from"></mat-datepicker-toggle>
        <mat-datepicker #from></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline" class="bd-field">
        <mat-label>Hasta</mat-label>
        <mat-icon matPrefix>event</mat-icon>
        <input matInput [matDatepicker]="to" [(ngModel)]="toDate" required />
        <mat-datepicker-toggle matSuffix [for]="to"></mat-datepicker-toggle>
        <mat-datepicker #to></mat-datepicker>
      </mat-form-field>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="bd-actions">
    <button mat-stroked-button (click)="closeDialog()">Cancelar</button>
    <button mat-flat-button class="bd-btn-export" (click)="getBalance()"
            [disabled]="!fromDate || !toDate">
      <mat-icon>file_download</mat-icon>
      Generar Excel
    </button>
  </mat-dialog-actions>
</ng-container>
